module.exports = __webpack_public_path__ + "static/dr-malcolm-ball-b0b05e07baed09d06a0d27946e8555a7.png";